import React from 'react';
import style from './Hero.module.scss';
import heroLogoImg from '../imgs/logo-mobile-view.png';

const Hero = () => (
    <section className={style.hero}>
        <div className={style.heroMap}></div>
        <div className={`px-5 wrap ${style.heroInner}`}>
            <div>
                <div className={style.eyebrow}>A map full of moments</div>
                <h1 className={style.title}>
                    Every place<br />has a story.<br /><em>Press play</em> when you arrive.
                </h1>
                <p className={style.sub}>
                    Yesterday stories pins short films to the exact location where that history happened. Find the stories near you.

                </p>
                <div className={style.actions}>
                    <a href="#stories" className={style.btnPrimary}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 1.5 12 7 3 12.5V1.5Z" fill="#101B29" /></svg>
                        Watch a story
                    </a>
                    <a href="#about" className={style.btnGhost}>Download the app</a>
                </div>
            </div>
            <div className={style.heroLogo}>
                <img src={heroLogoImg} alt="Yesterday Stories" />
            </div>
        </div>
    </section>
);

export default Hero;
